import { createSlice } from "@reduxjs/toolkit";

const inplaySlice = createSlice({
  name: "inplayCounts",
  initialState: {
    cricket: 0,
    tennis: 0,
    soccer: 0,
  },
  reducers: {
    setInplayCounts: (state, action) => {
      state.cricket = action.payload.cricket;
      state.tennis = action.payload.tennis;
      state.soccer = action.payload.soccer;
    },
  },
});

export const { setInplayCounts } = inplaySlice.actions;
export default inplaySlice.reducer;
